let FIREBASE_APP_SINGLETON = null;

const ERR_DUPLICATE_APP = 'app/duplicate-app';

export function getFirebaseApp() {
  return FIREBASE_APP_SINGLETON;
}

export function initWithConfig(firebase, config) {
  if (FIREBASE_APP_SINGLETON) {
    return FIREBASE_APP_SINGLETON;
  }
  try {
    FIREBASE_APP_SINGLETON = firebase.initializeApp(config);
    firebase.auth().useDeviceLanguage();
    if (config.measurementId) {
      firebase.analytics();
    }
  } catch (err) {
    if (err.code !== ERR_DUPLICATE_APP) {
      throw err;
    }
  }
  return FIREBASE_APP_SINGLETON;
}
